<template>
  <v-dialog
    v-model="dialog"
    persistent
    :content-class="isDarkMode ? 'dark-mode' : ''"
    width="fit-content"
  >
    <v-card class="bg-white">
      <v-card-title class="fs-1-5r bg-grey title">
        {{ $t('Permanent Sending Link') }}
      </v-card-title>
      <div class="bg-white d-flex justify-space-between pa-4">
        <Button :text="$t('Copy Link')" :clickAction="copyLink" />
        <Button
          :text="$t('Change Link')"
          :clickAction="renewLinkClicked"
        />
      </div>
      <v-divider></v-divider>
      <div class="d-flex justify-end px-4 py-2">
        <Button
          :text="$t('Close')"
          :clickAction="closeDialog"
          btnType="grey"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import Language from '@/components/PageParts/Header/Childrens/Language/Language.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'PermanentLinkDialog',
  data: () => ({
    dialog: true,
  }),
  components: {
    Button,
  },
  props: {
    closeDialog: Function,
    renewLinkClicked: Function,
    permanentLink: String,
  },
  computed: {
    ...mapGetters(['isDarkMode', 'language']),
  },
  methods: {
    ...mapMutations(['SET_NOTIFICATION']),
    async copyLink() {
      await navigator.clipboard.writeText(this.permanentLink)
      this.SET_NOTIFICATION({
        text: this.$t('Link copied to clipboard'),
        type: 'success',
      })
    },
  },
  created() {
    console.log(this.permanentLink)
  },
}
</script>
<style scoped>
.close-btn {
  font-size: 24px !important;
  position: relative !important;
  top: -6px !important;
}
.close-btn-en {
  right: -7px !important;
}
.close-btn-he {
  right: 7px !important;
}
.title {
  min-width: 270px;
}
</style>
